import React, { useState } from 'react';
import styles from './Footer.module.css';

import ChargeModal from '../ChargeModal/ChargeModal';
import Rights from './Rights/Rights';
import Main from './Main/Main';

const Footer: React.FC = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false);

  const showModal = () => {
    setModalIsVisible(true);
  };

  const hideModal = () => {
    setModalIsVisible(false);
  };

  return (
    <footer className={styles.newFooter}>
      <div className="container-fluid">
        { modalIsVisible ? <ChargeModal hide={hideModal} /> : null}
        <Main showModal={showModal} />
        <Rights />
      </div>
    </footer>
  );
};

export default Footer;
